import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { FolderContentPage } from './pages/FolderContentPage';
import { DiagramPage } from './pages/DiagramPage';
import { SynthesisPage } from './pages/SynthesisPage';
import { WorkloadPage } from './pages/WorkloadPage';
import { MasterPage } from './pages/MasterPage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { LogosPage } from './pages/LogosPage';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route index element={<FolderContentPage />} />
            <Route path="folders/:folderId" element={<FolderContentPage />} />
            <Route path="diagrams/:diagramId" element={<DiagramPage />} />
            <Route path="folders/:folderId/synthesis/:type" element={<SynthesisPage />} />
            <Route path="folders/:folderId/workload/:role/:userId" element={<WorkloadPage />} />
            <Route path="folders/:folderId/master" element={<MasterPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="logos" element={<LogosPage />} />
            <Route element={<AdminRoute />}>
              <Route path="admin/users" element={<AdminUsersPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}
